import type Konva from "konva";

export enum ShapeType {
  Line = "line",
  Rectangle = "rectangle",
  Ellipse = "ellipse",
  Arrow = "arrow",
  Text = "text",
  Spotlight = "spotlight",
}

export type CommonShapeConfig = {
  id: string;
  layerIndex: number;
  type: ShapeType;
  startX: number;
  startY: number;
  isNew?: boolean;
};

export type Shape = Konva.ShapeConfig & CommonShapeConfig;
